import { render, staticRenderFns } from "./LeaseItemsTabScreen.vue?vue&type=template&id=06670676&"
import script from "./LeaseItemsTabScreen.vue?vue&type=script&lang=js&"
export * from "./LeaseItemsTabScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06670676')) {
      api.createRecord('06670676', component.options)
    } else {
      api.reload('06670676', component.options)
    }
    module.hot.accept("./LeaseItemsTabScreen.vue?vue&type=template&id=06670676&", function () {
      api.rerender('06670676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/screens/LeaseDetailsScreen/LeaseItemsTabScreen.vue"
export default component.exports